import React from 'react';
import { bool, func } from 'prop-types';

import {
  Wrapper,
  InnerWrapper,
  Logo,
  LogoItem,
  NavItems,
  ExternalNavItem,
  BurgerWrapper,
  ShowMobileStatusButton,
  LBLogo,
} from './styles';
import Burger from '../Burger';

Navbar.propTypes = {
  menuOpen: bool.isRequired,
  toggleMenu: func.isRequired,
  isStartPage: bool.isRequired,
  attentionDot: bool.isRequired,
  makeSpaceForNotificationBar: bool.isRequired,
  statusBarOpen: bool.isRequired,
  toggleStatusBar: func.isRequired,
};

function Navbar({
  menuOpen,
  toggleMenu,
  isStartPage,
  attentionDot,
  makeSpaceForNotificationBar,
  statusBarOpen,
  toggleStatusBar,
}) {
  return (
    <Wrapper makeSpaceForNotificationBar={makeSpaceForNotificationBar}>
      <InnerWrapper>
        <BurgerWrapper hidden={isStartPage}>
          <Burger
            open={menuOpen}
            clicked={toggleMenu}
            attention={attentionDot}
          />
        </BurgerWrapper>

        <Logo>
          <LogoItem hideOnMobile={!isStartPage} primary>
            <LBLogo />
          </LogoItem>
          <LogoItem>bytesansökan</LogoItem>
        </Logo>

        <NavItems>
          {!window.isBytesansokanSe && (
            <ExternalNavItem
              showMobile={menuOpen}
              to="https://lagenhetsbyte.se/">
              Gå tillbaka till Lägenhetsbyte
            </ExternalNavItem>
          )}
          <ShowMobileStatusButton show={!menuOpen} onClick={toggleStatusBar}>
            {statusBarOpen ? 'Dölj status' : 'Visa status'}
          </ShowMobileStatusButton>
        </NavItems>
      </InnerWrapper>
    </Wrapper>
  );
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js